export default __webpack_public_path__ + "static/media/Metatheory-logo-white.5d0acdf0.png";